import {
  put, takeLatest, all,
} from 'redux-saga/effects';
import { notification } from 'antd';
import ProductActions, { productActionTypes } from '@Actions/productActions';
import TrackerActions from '@Actions/trackerActions';
import ProductService from '@Services/productServices';

/**
 * @param action
 */
function* _getProductById(action) {
  try {
    yield put(ProductActions.getProductByIdSuccess(null));
    yield put(ProductActions.getProductByIdLoading(true));
    const {
      tenantId, productSkuId, tenantDepartmentId, filterReservedBatches, productSkuIds,
    } = action;
    const selectedProduct = yield ProductService.getProductsById(tenantId, productSkuId, tenantDepartmentId, filterReservedBatches, productSkuIds);
    if (action.callback) {
      if (productSkuIds) {
        action.callback(selectedProduct?.result?.products);
      } else {
        action.callback(selectedProduct?.result?.products?.[0]);
      }
    }
    yield put(ProductActions.getProductByIdSuccess(productSkuIds ? selectedProduct?.result?.products : selectedProduct?.result?.products?.[0]));
    yield put(ProductActions.getProductByIdLoading(false));
  } catch (error) {
    yield put(ProductActions.getProductByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productActionTypes.GET_PRODUCT_BY_ID.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getProductById() {
  yield takeLatest(productActionTypes.GET_PRODUCT_BY_ID.REQUEST, _getProductById);
}

/**
 * @param action
 */
function* _searchProducts(action) {
  const { params } = action;
  try {
    yield put(ProductActions.searchProductsLoading(true, params.isAdvanceProductSearch));
    const searchResults = yield ProductService.getProducts(params?.keyword, params?.tenantId, params?.stockStatus, params?.page, params?.limit, params?.tenantDepartmentId, params?.excludeOutOfStock, params?.productType, params?.category, params?.isSalesProduct, params?.isPurchaseProduct, params?.search, '', params?.filterReservedQuantity, params?.barcode, params?.isShopifyProduct, params?.isMarketplaceProduct, params?.productSkuIds, params?.departmentId, params?.advanceFilters);
    if (searchResults?.success) {
      yield put(ProductActions.searchProductsSuccess({
        ...searchResults,
        keyword: params?.keyword,
      }, params.isAdvanceProductSearch));
    }
    if (action?.callback) {
      action.callback(searchResults?.result?.products?.[0]);
    }
    if (action?.newCallback) {
      action.newCallback(searchResults?.result?.products);
    }
    yield put(ProductActions.searchProductsLoading(false, params.isAdvanceProductSearch));
  } catch (error) {
    yield put(ProductActions.searchProductsLoading(false, params.isAdvanceProductSearch));
    yield put(TrackerActions.trackAction(productActionTypes.SEARCH_PRODUCTS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* searchProducts() {
  yield takeLatest(productActionTypes.SEARCH_PRODUCTS.REQUEST, _searchProducts);
}

function* _searchByReferenceId(action) {
  try {
    yield put(ProductActions.searchByReferenceIdLoading(true));
    const { params } = action;
    const searchResults = yield ProductService.getProducts(params?.keyword, params?.tenantId, params?.stockStatus, params?.page, params?.limit, params?.tenantDepartmentId, params?.excludeOutOfStock, params?.productType, params?.category, params?.isSalesProduct, params?.isPurchaseProduct, params?.search, '', params?.filterReservedQuantity, params?.barcode, params?.isShopifyProduct);
    if (searchResults?.success) {
      yield put(ProductActions.searchByReferenceIdSuccess({
        ...searchResults,
        keyword: params?.keyword,
      }));
    }
    if (action?.callback) {
      action.callback(searchResults?.result?.products?.[0]);
    }
    yield put(ProductActions.searchByReferenceIdLoading(false));
  } catch (error) {
    yield put(ProductActions.searchByReferenceIdLoading(false));
    yield put(TrackerActions.trackAction(productActionTypes.SEARCH_BY_REFERENCE_ID.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* searchByReferenceId() {
  yield takeLatest(productActionTypes.SEARCH_BY_REFERENCE_ID.REQUEST, _searchByReferenceId);
}


/**
 * @param action
 */
function* _getProducts(action) {
  try {
    yield put(ProductActions.getProductsLoading(true));
    const products = yield ProductService.getProducts(action.keyword, action.tenantId, action.stockStatus, action.page, action.limit, action.tenantDepartmentId, action.excludeOutOfStock, action.productType, action.category, action.isSalesProduct, action.isPurchaseProduct, action.search, action.sortBy, action.filterReservedQuantity, action.barcode, action.isShopifyProduct, action.isMarketplaceProduct, '', (action?.departmentId === 'all' ? null : action?.departmentId), action.advanceFilters,action.isListScreen);
    yield put(ProductActions.getProductsSuccess(products, action.forOffers));
    yield put(ProductActions.getProductsLoading(false));
  } catch (error) {
    yield put(ProductActions.getProductsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productActionTypes.GET_PRODUCTS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getProducts() {
  yield takeLatest(productActionTypes.GET_PRODUCTS.REQUEST, _getProducts);
}

/**
 * @param action
 */
function* _getLowOrgProducts(action) {
  try {
    yield put(ProductActions.getLowOrgProductsLoading(true));
    const products = yield ProductService.getLowOrgProducts(action.page, action.tenantId);
    yield put(ProductActions.getLowOrgProductsSuccess(products));
    yield put(ProductActions.getLowOrgProductsLoading(false));
  } catch (error) {
    yield put(ProductActions.getLowOrgProductsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productActionTypes.GET_LOW_ORG_PRODUCTS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getLowOrgProducts() {
  yield takeLatest(productActionTypes.GET_LOW_ORG_PRODUCTS.REQUEST, _getLowOrgProducts);
}

/**
 * @param action
 */
function* _addProductVendor(action) {
  try {
    yield put(ProductActions.addProductVendorLoading(true));
    const productVendor = yield ProductService.addProductVendor(action.payload);
    if (productVendor.success) {
      notification.open({
        type: 'success',
        message: 'Product added successfully!',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: productVendor.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ProductActions.addProductVendorLoading(false));
  } catch (error) {
    yield put(ProductActions.addProductVendorLoading(false));
    yield put(TrackerActions.trackAction(productActionTypes.ADD_PRODUCT_VENDOR.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* addProductVendor() {
  yield takeLatest(productActionTypes.ADD_PRODUCT_VENDOR.REQUEST, _addProductVendor);
}

/**
 * @param action
 */
function* _addProductToInventory(action) {
  try {
    yield put(ProductActions.addProductToInventoryLoading(true));
    const productVendor = yield ProductService.addProductToInventory(action.payload);
    if (productVendor.product_sku) {
      yield put(TrackerActions.trackAction(productActionTypes.ADD_PRODUCT_TO_INV.SUCCESS, {
        request: action?.payload,
        response: productVendor,
      }));

      notification.open({
        type: 'success',
        message: 'Product update to your inventory',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(productVendor.product_sku);
      }
    } else {
      notification.open({
        type: 'error',
        message: productVendor.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ProductActions.addProductToInventoryLoading(false));
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productActionTypes.ADD_PRODUCT_TO_INV.ERROR, {
      request: action,
      error,
    }));
    yield put(ProductActions.addProductToInventoryLoading(false));
  }
}

/**
 *
 */
function* addProductToInventory() {
  yield takeLatest(productActionTypes.ADD_PRODUCT_TO_INV.REQUEST, _addProductToInventory);
}

/**
 * @param action
 */
function* _updateProductToInventory(action) {
  try {
    yield put(ProductActions.updateProductToInventoryLoading(true));
    const productVendor = yield ProductService.updateProductToInventory(action.payload);
    if (productVendor.product_sku) {
      yield put(TrackerActions.trackAction(productActionTypes.UPDATE_PRODUCT_TO_INV.SUCCESS, {
        request: action?.payload,
        response: productVendor,
      }));
      notification.open({
        type: 'success',
        message: 'Product information updated successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: productVendor.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ProductActions.updateProductToInventoryLoading(false));
  } catch (error) {
    yield put(ProductActions.updateProductToInventoryLoading(false));
    yield put(TrackerActions.trackAction(productActionTypes.UPDATE_PRODUCT_TO_INV.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* updateProductToInventory() {
  yield takeLatest(productActionTypes.UPDATE_PRODUCT_TO_INV.REQUEST, _updateProductToInventory);
}

/**
 * @param action
 */
function* _updateIndentStatus(action) {
  try {
    yield put(ProductActions.updateIndentStatusLoading(true));
    const indent = yield ProductService.updateIndentStatus(action.payload);
    if (indent.success) {
      notification.open({
        type: 'success',
        message: 'Updated Adjustment status successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: indent?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ProductActions.updateIndentStatusLoading(false));
  } catch (error) {
    yield put(ProductActions.updateIndentStatusLoading(false));
    yield put(TrackerActions.trackAction(productActionTypes.UPDATE_INDENT_STATUS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* updateIndentStatus() {
  yield takeLatest(productActionTypes.UPDATE_INDENT_STATUS.REQUEST, _updateIndentStatus);
}

/**
 * @param action
 */
function* _createIndent(action) {
  try {
    yield put(ProductActions.createIndentLoading(true));
    const indent = yield ProductService.createIndent(action.payload);
    if (indent.success) {
      yield put(TrackerActions.trackAction(productActionTypes.CREATE_INDENT.SUCCESS, {
        request: action?.payload,
        response: indent,
      }));
      notification.open({
        type: 'success',
        message: 'Created Adjustment successfully',
        duration: 4,
        placement: 'top',
      });

      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: indent.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ProductActions.createIndentLoading(false));
  } catch (error) {
    yield put(ProductActions.createIndentLoading(false));
    yield put(TrackerActions.trackAction(productActionTypes.CREATE_INDENT.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* createIndent() {
  yield takeLatest(productActionTypes.CREATE_INDENT.REQUEST, _createIndent);
}

/**
 * @param action
 */
function* _updateIndent(action) {
  try {
    yield put(ProductActions.updateIndentLoading(true));
    const indent = yield ProductService.updateIndent(action.payload);
    if (indent.success) {
      yield put(TrackerActions.trackAction(productActionTypes.UPDATE_INDENT.SUCCESS, {
        request: action?.payload,
        response: indent,
      }));
      notification.open({
        type: 'success',
        message: 'Updated Adjustment successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.withApproval && action.callback) {
        const updateStatusPayload = {
          ia_id: indent?.inventory_adjustment?.ia_id,
          tenant_id: action?.payload?.inventory_tenant_id,
          status: 'ISSUED',
        };
        yield put(ProductActions.updateIndentStatus(updateStatusPayload, action?.callback));
        action.callback();
      }
      if (!action.withApproval && action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: indent?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ProductActions.updateIndentLoading(false));
  } catch (error) {
    yield put(ProductActions.updateIndentLoading(false));
    yield put(TrackerActions.trackAction(productActionTypes.UPDATE_INDENT.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* updateIndent() {
  yield takeLatest(productActionTypes.UPDATE_INDENT.REQUEST, _updateIndent);
}

/**
 * @param action
 */
function* _getIndent(action) {
  try {
    yield put(ProductActions.getIndentLoading(true));
    const indent = yield ProductService.getIndent(
      action.page, action.tenantId, action.indentId, action.adjustmentEntityType, action.searchKeyword, action.department, action.limit,
    );
    yield put(ProductActions.getIndentSuccess(indent));
    yield put(ProductActions.getIndentLoading(false));
  } catch (error) {
    yield put(ProductActions.getIndentLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productActionTypes.GET_INDENT.ERROR, error));
  }
}

/**
 *
 */
function* getIndent() {
  yield takeLatest(productActionTypes.GET_INDENT.REQUEST, _getIndent);
}

/**
 * @param action
 */
function* _setDefaultOffer(action) {
  try {
    yield put(ProductActions.setDefaultOfferLoading(true));
    const defaultOffer = yield ProductService.setDefaultOffer(action.payload);
    if (action.callback) {
      action.callback();
    }
    yield put(ProductActions.setDefaultOfferLoading(false));
  } catch (error) {
    yield put(ProductActions.setDefaultOfferLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productActionTypes.SET_DEFAULT_OFFER.ERROR, error));
  }
}

/**
 *
 */
function* setDefaultOffer() {
  yield takeLatest(productActionTypes.SET_DEFAULT_OFFER.REQUEST, _setDefaultOffer);
}

/**
 * @param action
 */
function* _getProductOffers(action) {
  try {
    yield put(ProductActions.getProductOffersLoading(true));
    const products = yield ProductService.getProducts('', action.tenantId, null, action.productSkuId);
    yield put(ProductActions.getProductOffersSuccess(products?.result?.products[0]));
    yield put(ProductActions.getProductOffersLoading(false));
  } catch (error) {
    yield put(ProductActions.getProductOffersLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productActionTypes.GET_PRODUCT_OFFERS.ERROR, error));
  }
}

/**
 *
 */
function* getProductOffers() {
  yield takeLatest(productActionTypes.GET_PRODUCT_OFFERS.REQUEST, _getProductOffers);
}

/**
 * @param action
 */
function* _getSellerProducts(action) {
  try {
    yield put(ProductActions.getSellerProductsLoading(true));
    const {
      tenantId, sellerId, productName, page, limit,
    } = action;
    const sellerProducts = yield ProductService.getSellerProducts(tenantId, sellerId, productName, page, limit);
    yield put(ProductActions.getSellerProductsSuccess(sellerProducts));
    yield put(ProductActions.getSellerProductsLoading(false));
  } catch (error) {
    yield put(ProductActions.getSellerProductsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productActionTypes.GET_SELLER_PRODUCTS.ERROR, error));
  }
}

/**
 *
 */
function* getSellerProducts() {
  yield takeLatest(productActionTypes.GET_SELLER_PRODUCTS.REQUEST, _getSellerProducts);
}

/**
 * @param action
 */
function* _getIndentById(action) {
  try {
    yield put(ProductActions.getIndentByIdLoading(true));
    const indent = yield ProductService.getIndent(1, action.tenantId, action.indentId, '', '', '', action.limit);
    yield put(ProductActions.getIndentByIdSuccess(indent?.result?.inventory_adjustments?.[0]));
    yield put(ProductActions.getIndentByIdLoading(false));
  } catch (error) {
    yield put(ProductActions.getIndentByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productActionTypes.GET_INDENT_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getIndentById() {
  yield takeLatest(productActionTypes.GET_INDENT_BY_ID.REQUEST, _getIndentById);
}

/**
 * @param action
 */
function* _getOrgProducts(action) {
  try {
    yield put(ProductActions.getOrgProductsLoading(true));
    const orgProducts = yield ProductService.getOrgProducts(action.orgId, action.tenantId, action.page, action.limit, action.keyword, action.stockStatus, action.tenantDepartmentId, action.productSkuId, action.productType, action.category, action.isSalesProduct, action.isPurchaseProduct, action.isArchive);

    yield put(ProductActions.getOrgProductsSuccess(orgProducts));
    yield put(ProductActions.getOrgProductsLoading(false));
  } catch (error) {
    yield put(ProductActions.getOrgProductsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productActionTypes.GET_ORG_PRODUCTS.ERROR, error));
  }
}

/**
 *
 */
function* getOrgProducts() {
  yield takeLatest(productActionTypes.GET_ORG_PRODUCTS.REQUEST, _getOrgProducts);
}

/**
 * @param action
 */
function* _getOrgProductById(action) {
  try {
    yield put(ProductActions.getOrgProductByIdLoading(true));
    const orgProduct = yield ProductService.getOrgProducts(action.orgId, action.tenantId, 1, 10, '', '', '', action.productSkuId, '', '', null, null, null, action.pendingFromVendor, action.productSkuIds);
    yield put(ProductActions.getOrgProductByIdSuccess(orgProduct?.products?.[0]));
    if (action.callback) {
      if (action.productSkuIds) {
        action.callback(orgProduct?.products);
      } else {
        action.callback(orgProduct?.products?.[0]);
      }
    }
    yield put(ProductActions.getOrgProductByIdLoading(false));
  } catch (error) {
    yield put(ProductActions.getOrgProductByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productActionTypes.GET_ORG_PRODUCT_BY_ID.ERROR, error));
  }
}

/**
 *
 * @return {Generator<*, void, *>}
 */
function* getOrgProductById() {
  yield takeLatest(productActionTypes.GET_ORG_PRODUCT_BY_ID.REQUEST, _getOrgProductById);
}

/**
 * @param action
 */
function* _deleteIndent(action) {
  try {
    yield put(ProductActions.deleteIndentLoading(true));
    const indent = yield ProductService.deleteIndent(action.payload);
    if (indent.success) {
      notification.open({
        type: 'success',
        message: 'Deleted Adjustment successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: indent?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ProductActions.deleteIndentLoading(false));
  } catch (error) {
    yield put(ProductActions.deleteIndentLoading(false));
    yield put(TrackerActions.trackAction(productActionTypes.DELETE_INDENT.ERROR, error));
  }
}

/**
 *
 */
function* deleteIndent() {
  yield takeLatest(productActionTypes.DELETE_INDENT.REQUEST, _deleteIndent);
}

/**
 * @param action
 */
function* _getRecentTransactions(action) {
  try {
    yield put(ProductActions.getRecentTransactionsSuccess(null));
    yield put(ProductActions.getRecentTransactionsLoading(true));
    const { payload } = action;
    const {
      tenantId, productSkuId, sellerId, rangeDays, costumerID, typeOfTransaction,
    } = payload;
    const recentTxn = yield ProductService.getRecentTransactions(tenantId, productSkuId, sellerId, rangeDays, costumerID, typeOfTransaction);
    yield put(ProductActions.getRecentTransactionsSuccess(recentTxn));
    yield put(ProductActions.getRecentTransactionsLoading(false));
  } catch (error) {
    yield put(ProductActions.getRecentTransactionsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productActionTypes.GET_RECENT_TRANSACTIONS.ERROR, error));
  }
}

/**
 *
 */
function* getRecentTransactions() {
  yield takeLatest(productActionTypes.GET_RECENT_TRANSACTIONS.REQUEST, _getRecentTransactions);
}

/**
 * @param action
 */
function* _getInventoryLogs(action) {
  try {
    yield put(ProductActions.getInventoryLogsSuccess(null));
    yield put(ProductActions.getInventoryLogsLoading(true));
    const {
      tenantId, orgId, tenantProductId, productSkuId, page, limit, tenantDepartmentId, startDate, endDate, searchKeyword,
    } = action;
    const inventoryLogs = yield ProductService.getInventoryLogs(tenantId, orgId, tenantProductId, productSkuId, page, limit, tenantDepartmentId, startDate, endDate, searchKeyword);
    yield put(ProductActions.getInventoryLogsSuccess(inventoryLogs));
    yield put(ProductActions.getInventoryLogsLoading(false));
  } catch (error) {
    yield put(ProductActions.getInventoryLogsLoading(false));
    yield put(TrackerActions.trackAction(productActionTypes.GET_INVENTORY_LOGS.ERROR, error));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 */
function* getInventoryLogs() {
  yield takeLatest(productActionTypes.GET_INVENTORY_LOGS.REQUEST, _getInventoryLogs);
}

/**
 * @param action
 */
function* _getProductBySkus(action) {
  try {
    yield put(ProductActions.getProductBySkusSuccess(null));
    yield put(ProductActions.getProductBySkusLoading(true));
    const {
      payload,
    } = action;
    const selectedProductsSkuCode = yield ProductService.getProductBySkus(payload);
    if (!selectedProductsSkuCode.success) {
      notification.open({
        type: 'error',
        message: selectedProductsSkuCode.message,
        duration: 4,
        placement: 'top',
      });
    } else if (action.callback) {
      action.callback(selectedProductsSkuCode);
    }

    yield put(ProductActions.getProductBySkusSuccess(selectedProductsSkuCode));
    yield put(ProductActions.getProductBySkusLoading(false));
  } catch (error) {
    yield put(ProductActions.getProductBySkusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productActionTypes.GET_PRODUCT_BY_SKUS.ERROR, error));
  }
}

/**
 *
 */
function* getProductBySkus() {
  yield takeLatest(productActionTypes.GET_PRODUCT_BY_SKUS.REQUEST, _getProductBySkus);
}

function* __getSellerCodes(action) {
  try {
    yield put(ProductActions.getSellerCodesSuccess(null));
    yield put(ProductActions.getSellerCodesLoading(true));
    const {
      sellerCode, orgId,
    } = action;
    const selectedSellerCode = yield ProductService.getSellerCodes(sellerCode, orgId);
    if (!selectedSellerCode.success) {
      notification.open({
        type: 'error',
        message: selectedSellerCode.message,
        duration: 4,
        placement: 'top',
      });
    } else if (action.callback) {
      action.callback(selectedSellerCode);
    }

    yield put(ProductActions.getSellerCodesSuccess(selectedSellerCode));
    yield put(ProductActions.getSellerCodesLoading(false));
  } catch (error) {
    yield put(ProductActions.getSellerCodesLoading(false));
    notification.open({
      type: 'error',
      message: 'Error occurred while retrieving product',
      description: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productActionTypes.GET_SELLER_CODES.ERROR, error));
  }
}

/**
 *
 */
function* getSellerCodes() {
  yield takeLatest(productActionTypes.GET_SELLER_CODES.REQUEST, __getSellerCodes);
}

function* _printBarcodes(action) {
  try {
    yield put(ProductActions.printBarcodesSuccess(null));
    yield put(ProductActions.printBarcodesLoading(true));
    const {
      payload, callback,
    } = action;
    const printedBarcodes = yield ProductService.printBarcodes(payload);
    if (printedBarcodes.success) {
      yield put(ProductActions.printBarcodesSuccess(printedBarcodes?.html));
      if (callback) {
        callback(printedBarcodes?.html);
      }
    } else {
      notification.open({
        type: 'error',
        message: printedBarcodes.error,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ProductActions.printBarcodesLoading(false));
  } catch (error) {
    yield put(ProductActions.printBarcodesLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productActionTypes.GET_PRODUCT_BY_SKUS.ERROR, error));
  }
}

function* printBarcodes() {
  yield takeLatest(productActionTypes.PRINT_BARCODE.REQUEST, _printBarcodes);
}

function* _updateSAWorkflowStep(action) {
  try {
    yield put(ProductActions.updateSAWorkflowStepLoading(true));
    const { payload } = action;
    const stockAdjustment = yield ProductService.updateSAWorkflowStep(payload);
    if (stockAdjustment.success) {
      notification.open({
        type: 'success',
        message: 'Stock Adjustment approval status updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(stockAdjustment);
      }
    } else {
      notification.open({
        type: 'error',
        message: stockAdjustment.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ProductActions.updateSAWorkflowStepLoading(false));
  } catch (error) {
    yield put(ProductActions.updateSAWorkflowStepLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(ProductActions.trackAction(productActionTypes.UPDATE_SA_WORKFLOW_STEP.ERROR, error));
  }
}

/**
 *
 */
function* updateSAWorkflowStep() {
  yield takeLatest(productActionTypes.UPDATE_SA_WORKFLOW_STEP.REQUEST, _updateSAWorkflowStep);
}

// Download Product Batches List

function* _downloadProductBatchesList(action) {
  try {
    yield put(ProductActions.downloadProductBatchesListLoading(true));
    const { payload } = action;
    const productBatches = yield ProductService.downloadProductBatchesList(payload);
    if (productBatches.success) {
      notification.open({
        type: 'success',
        message: 'We are processing your request. You will receive the data on your email.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: productBatches.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ProductActions.downloadProductBatchesListLoading(false));
  } catch (error) {
    yield put(ProductActions.downloadProductBatchesListLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* downloadProductBatchesList() {
  yield takeLatest(productActionTypes.DOWNLOAD_PRODUCT_BATCHES_LIST.REQUEST, _downloadProductBatchesList);
}

// Download Inventory logs

function* _downloadInventoryLogs(action) {
  try {
    yield put(ProductActions.downloadInventoryLogsLoading(true));
    const { payload } = action;
    const inventoryLogs = yield ProductService.downloadInventoryLogs(payload);
    if (inventoryLogs.success) {
      notification.open({
        type: 'success',
        message: 'We are processing your request. You will receive the data on your email.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: inventoryLogs.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ProductActions.downloadInventoryLogsLoading(false));
  } catch (error) {
    yield put(ProductActions.downloadInventoryLogsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* downloadInventoryLogs() {
  yield takeLatest(productActionTypes.DOWNLOAD_INVENTORY_LOGS.REQUEST, _downloadInventoryLogs);
}


/**
 *
 * @param action
 * @returns {Generator<Promise<*>|*, void, *>}
 * @private
 */
function* _bulkUpdateProducts(action) {
  try {
    yield put(ProductActions.bulkUpdateProductsLoading(true));
    const { payload } = action;
    const bulkUpload = yield ProductService.bulkUpdateProducts(payload);
    if (bulkUpload.success) {
      notification.open({
        type: 'success',
        message: 'We are processing your request. You will receive the data on your email.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: bulkUpload.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ProductActions.bulkUpdateProductsLoading(false));
  } catch (error) {
    yield put(ProductActions.bulkUpdateProductsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 * @returns {Generator<*, void, *>}
 */
function* bulkUpdateProducts() {
  yield takeLatest(productActionTypes.BULK_UPDATE_PRODUCTS.REQUEST, _bulkUpdateProducts);
}

/**
 *
 * @returns {Generator<Promise<*>|*, void, *>}
 * @private
 */
function* _getBulkUploadMetadata() {
  try {
    yield put(ProductActions.getBulkUploadMetadataLoading(true));
    yield put(ProductActions.bulkUploadProductsError(null));
    const bulkUploadMetaData = yield ProductService.getBulkUploadMetadata();
    if (bulkUploadMetaData.success) {
      yield put(ProductActions.getBulkUploadMetadataSuccess(bulkUploadMetaData));
    } else {
      notification.open({
        type: 'error',
        message: 'Something went wrong while initiating your request',
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ProductActions.getBulkUploadMetadataLoading(false));
  } catch (error) {
    yield put(ProductActions.getBulkUploadMetadataLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

/**
 *
 * @returns {Generator<*, void, *>}
 */
function* getBulkUploadMetadata() {
  yield takeLatest(productActionTypes.GET_BULK_UPLOAD_META_DATA.REQUEST, _getBulkUploadMetadata);
}

function* _bulkUploadProducts(action) {
  try {
    yield put(ProductActions.bulkUploadProductsLoading(true));
    yield put(ProductActions.bulkUploadProductsError(null));
    const { payload } = action;
    const bulkUpload = yield ProductService.bulkUploadProducts(payload);
    if (bulkUpload.success) {
      yield put(ProductActions.bulkUploadProductsSuccess(bulkUpload));
      notification.open({
        type: 'success',
        message: 'We are processing your request. Please check the status on bulk imports section.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      };
    } else {
      yield put(ProductActions.bulkUploadProductsError(bulkUpload.error));
    }
    yield put(ProductActions.bulkUploadProductsLoading(false));
  } catch (error) {
    yield put(ProductActions.bulkUploadProductsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* bulkUploadProducts() {
  yield takeLatest(productActionTypes.BULK_UPLOAD_PRODUCT.REQUEST, _bulkUploadProducts);
}

function* _productsBulkUpdate(action) {
  try {
    yield put(ProductActions.productsBulkUpdateLoading(true));
    yield put(ProductActions.productsBulkUpdateError(null));
    const { payload } = action;
    const bulkUpdate = yield ProductService.productsBulkUpdate(payload);
    if (bulkUpdate.success) {
      yield put(ProductActions.bulkUploadProductsSuccess(bulkUpdate));
      notification.open({
        type: 'success',
        message: 'We are processing your request. Please check the status on bulk imports section.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      };
    } else {
      yield put(ProductActions.productsBulkUpdateError(bulkUpdate.error));
      notification.open({
        type: 'error',
        message: bulkUpdate.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(ProductActions.productsBulkUpdateLoading(false));
  } catch (error) {
    yield put(ProductActions.productsBulkUpdateLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* productsBulkUpdate() {
  yield takeLatest(productActionTypes.PRODUCTS_BULK_UPDATE.REQUEST, _productsBulkUpdate);
}

function* _getTallyProducts(action) {
  try {
    yield put(ProductActions.getTallyProductsSuccess(null));
    yield put(ProductActions.getTallyProductsLoading(true));
    const {
      itId, orgId, searchKeyword, selectedProduct, callback
    } = action;
    const tallyProducts = yield ProductService.getTallyProducts(itId, orgId, searchKeyword, selectedProduct);
    if (tallyProducts?.success) {
      yield put(ProductActions.getTallyProductsSuccess(tallyProducts?.data));
      if (callback) {
        action.callback();
      }
    }
    yield put(ProductActions.getTallyProductsLoading(false));
  } catch (error) {
    yield put(ProductActions.getTallyProductsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(productActionTypes.GET_TALLY_PRODUCTS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* getTallyProducts() {
  yield takeLatest(productActionTypes.GET_TALLY_PRODUCTS.REQUEST, _getTallyProducts);
}

export default function* productSaga() {
  yield all([
    getProductById(),
    searchProducts(),
    getProducts(),
    addProductVendor(),
    addProductToInventory(),
    updateProductToInventory(),
    getLowOrgProducts(),
    updateIndentStatus(),
    createIndent(),
    getIndent(),
    getIndentById(),
    updateIndent(),
    setDefaultOffer(),
    getProductOffers(),
    getSellerProducts(),
    getOrgProducts(),
    getOrgProductById(),
    deleteIndent(),
    getRecentTransactions(),
    getInventoryLogs(),
    getProductBySkus(),
    printBarcodes(),
    getSellerCodes(),
    updateSAWorkflowStep(),
    downloadProductBatchesList(),
    downloadInventoryLogs(),
    searchByReferenceId(),
    bulkUpdateProducts(),
    getBulkUploadMetadata(),
    bulkUploadProducts(),
    productsBulkUpdate(),
    getTallyProducts(),
  ]);
}
